module.exports = __webpack_public_path__ + "static/img/1.179c3b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-cn/1.jpg
// module id = m1fE
// module chunks = 1